export const TRANSLATED_ROUTES = [
  '',
  '/pricing',
  '/reports',
  '/reports/janampatri',
  '/reports/newborn-kundli',
  '/reports/career-dasha',
  '/reports/marriage-compatibility',
  '/reports/relationship',
  '/reports/financial-stability',
  '/reports/wealth-lifestyle',
  '/mangal-dosha-calculator',
  '/blog',
  '/birth-panchang-calculator',
  '/rahu-kaal-calculator',
  '/choghadiya-calculator',
  '/hora-calculator',
  '/moon-phase-calculator',
  '/panchang',
  '/kaal-sarp-calculator',
  '/pitra-dosha-calculator',
  '/sade-sati-calculator',
  '/nadi-dosha-calculator',
  '/transit-chart-calculator',
  '/ascendant-calculator',
  '/moon-sign-calculator',
  '/rashi-sign-calculator',
  '/sun-sign-calculator',
  '/nakshatra-calculator',
  '/baby-name-calculator',
  '/kundli-matching',
  '/marriage-compatibility-calculator',
  '/about',
  '/contact',
  '/support',
  '/privacy-policy',
  '/terms-of-service',
  '/login',
  '/register',
  '/reset-password'
] as const;

export type TranslatedRoute = (typeof TRANSLATED_ROUTES)[number];
